import { useSuspenseQuery } from '@tanstack/react-query'

import type { BusinessSummaryItem } from 'src/features/business/shared/schemas/business-item'
import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export interface GenericSearchHistoryItem {
  id: number
  rawQuery: string | null
  businessId: number | null
  targetUserId: number | null
  lastAccessedAt: string
}

export interface GenericSearchResponse {
  users: PublicUserData[]
  businesses: BusinessSummaryItem[]
  search?: GenericSearchHistoryItem[]
}

export interface GenericSearchParams {
  query?: string
  limit?: number
}

const EMPTY_GENERIC_SEARCH_RESPONSE: GenericSearchResponse = {
  users: [],
  businesses: [],
  search: [],
}

export const getGenericSearch = async ({ query, limit = 10 }: GenericSearchParams): Promise<GenericSearchResponse> => {
  try {
    const params = new URLSearchParams()
    if (query !== undefined) {
      params.append('query', query)
    }
    params.append('limit', limit.toString())

    const response = await getRequest<GenericSearchResponse>(`/users/search-v2?${params.toString()}`)
    return response ?? EMPTY_GENERIC_SEARCH_RESPONSE
  } catch (error) {
    console.error('Error fetching generic search:', error)
    return EMPTY_GENERIC_SEARCH_RESPONSE
  }
}

export const useGenericSearch = ({ query, limit = 10 }: GenericSearchParams) => {
  return useSuspenseQuery({
    queryKey: queries.search.generic(query, limit).queryKey,
    queryFn: () => getGenericSearch({ query, limit }),
  })
}
